<template>
  <div>
    <NavbarView :rainbow="false" />

    <button class="back-button" @click="$router.back()">
      ← Back
    </button>

    <h1>VISUALS</h1>

    <div v-if="items.length">
      <div class="td-grid">

        <div
        v-for="(item, index) in items"
        :key="item.id"
        class="td-card-wrapper"
        @click="openModal(index)"
      >
        <!-- TITLE -->
        <div class="td-title">{{ item.title }}</div>

        <!-- MEDIA (always a div, not a link) -->
        <div class="media-link">
          <img
            v-if="item.type === 'image' && item.url_content"
            :src="item.url_content"
            :alt="item.title"
          />
          <video
            v-else-if="item.type === 'video' && item.url_content"
            :src="item.url_content"
            muted
            loop
            playsinline
          />
          <div v-else class="placeholder">No preview</div>
        </div>

        <!-- ICONS BELOW MEDIA -->
        <div class="td-icons">
          <a
            v-if="item.url_youtube"
            :href="item.url_youtube"
            target="_blank"
            rel="noopener noreferrer"
            title="Watch on YouTube"
          >
            <img
              class="icon"
              src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/youtube.svg"
              alt="YouTube"
            />
          </a>
          <a
            v-if="item.file"
            :href="item.file"
            target="_blank"
            rel="noopener noreferrer"
            title="Download TouchDesigner file"
          >
            <img
              class="icon"
              src="https://upload.wikimedia.org/wikipedia/commons/1/1b/Derivative_TouchDesigner_logo.svg"
              alt="TouchDesigner"
            />
          </a>
        </div>
      </div>

      </div>
    </div>

    <!-- MODAL -->
    <div v-if="showModal" class="modal" @click.self="closeModal">
      <div class="modal-content">
        <button class="close-button" @click="closeModal">×</button>
        <video
          v-if="currentItem.type === 'video' && currentItem.url_content"
          :src="currentItem.url_content"
          autoplay
          controls
          playsinline
        />
        <img
          v-else-if="currentItem.type === 'image' && currentItem.url_content"
          :src="currentItem.url_content"
          :alt="currentItem.title"
        />
        <div class="modal-nav">
          <button @click="prevItem">←</button>
          <button @click="nextItem">→</button>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import NavbarView from '../../NavbarView.vue';

export default {
  name: 'GeometricWorldsView',
  components: { NavbarView },

  data() {
    return {
      items: [],
      showModal: false,
      currentIndex: 0,
    };
  },

  computed: {
    currentItem() {
      return this.items[this.currentIndex];
    }
  },

  mounted() {
    fetch('https://tommella-general-storage-83d44de1134b.herokuapp.com/apps/td/visuals/')
      .then(res => res.json())
      .then(data => {
        this.items = data;
      })
      .catch(err => {
        console.error('Fetch failed:', err);
      });
    window.addEventListener('keydown', this.handleKeyDown);
  },

  beforeUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
  },

  methods: {
    openModal(index) {
      this.currentIndex = index;
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    nextItem() {
      if (this.currentIndex < this.items.length - 1) {
        this.currentIndex++;
      }
    },
    prevItem() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
      }
    },
    handleKeyDown(e) {
      if (!this.showModal) return;
      if (e.key === 'ArrowRight') {
        this.nextItem();
      } else if (e.key === 'ArrowLeft') {
        this.prevItem();
      } else if (e.key === 'Escape') {
        this.closeModal();
      }
    }
  },
};
</script>


<style scoped>
/* ... (keep all your existing styles) ... */

/* Responsive grid: 3 columns by default, 1 column on small screens */
/* BASE (desktop) */
.td-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 60px 60px;
}

/* MOBILE */
@media (max-width: 768px) {
  .td-grid {
    grid-template-columns: 1fr;
    gap: 20px;
    padding: 0 10px 40px;
  }

  .back-button {
    top: 70px;
    left: 15px;
  }
}

h1 {
  text-align: center;
  margin: 100px 0 30px;
  font-size: 2.5em;      /* slightly bigger */
  color: #176219;        /* green */
}

/* title above each instance (card) */
.td-title {
  margin-bottom: 18px;
  margin-top: 18px;
  font-weight: 700;
  font-size: 1.5rem;     /* increased size */
  text-align: center;
  color: #000;
}

/* wrapper for title + rectangle */
.td-card-wrapper .media-link img,
.td-card-wrapper .media-link video {
  width: 90%;       /* smaller than container */
  height: 90%;
  object-fit: contain;
  border-radius: 8px;
  margin: auto;     /* center inside rectangle */
  display: block;
  background: #000; /* optional */
}

.td-description {
  margin-top: 12px;
  padding: 12px;
  background: #f5f5f5;
  border-radius: 8px;
  width: 100%;
  font-size: 0.9rem;
  color: #333;
  box-sizing: border-box;
  min-height: 50px; /* optional, makes all descriptions similar height */
  overflow: hidden;
  text-overflow: ellipsis;
}
/* rectangle: 3 width x 4 height ratio */
.td-card-wrapper .media-link,
.td-card-wrapper img,
.td-card-wrapper video,
.td-card-wrapper .placeholder {
  width: 100%;
  aspect-ratio: 1280 / 720; /* rectangle */
  border-radius: 10px;
  overflow: hidden;
  object-fit: cover;
  display: block;
}

/* placeholder styling */
.placeholder {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #111;
  color: white;
  font-size: 0.9rem;
}

.back-button {
  position: fixed;
  top: 90px;
  left: 30px;
  background: #eee;
  border: none;
  color: #333;
  padding: 8px 14px;
  border-radius: 20px;
  font-size: 0.9rem;
  cursor: pointer;
  z-index: 10;
}

.back-button:hover {
  background: #ddd;
}

/* ICONS UNDER MEDIA */
/* ICONS UNDER MEDIA */
.td-icons {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 2px;      /* ⬅ closer to the square */
}

/* ICON SIZE */
.td-icons .icon {
  width: 26px;          /* ⬅ bigger */
  height: 26px;
  opacity: 0.65;
  transition: opacity 0.2s ease, transform 0.2s ease;
}

/* HOVER EFFECT */
.td-icons .icon:hover {
  opacity: 1;
  transform: scale(1.15);
}


.youtube-icon {
  filter: grayscale(100%);
}

.youtube-icon:hover {
  filter: none;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
}

.modal-content {
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
  background: #000;
  border-radius: 8px;
  overflow: hidden;
}

.modal-content video,
.modal-content img {
  display: block;
  max-width: 100%;
  max-height: 80vh;
  margin: auto;
}

.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  color: white;
  font-size: 2rem;
  cursor: pointer;
  z-index: 101;
}

.modal-nav {
  position: absolute;
  bottom: 10px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
}

.modal-nav button {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 5px 15px;
  border-radius: 4px;
}


</style>
